var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        borderBottom: 'none',
        marginTop: '2rem',
        minHeight: '44px',
        flexWrap: 'wrap',
        gap: '4px 8px',
    },
    leftSpacer: {
        flex: 1,
        minWidth: 0,
    },
    navButtons: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '0 0 auto',
    },
    navButton: {
        width: '70px',
        height: '32px',
        minWidth: '70px',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        fontSize: '16px',
        color: '#171717',
        padding: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    navButtonDisabled: {
        opacity: 0.4,
    },
    title: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#323130',
        padding: '4px 8px',
        borderRadius: '2px',
    },
    titleClickable: {
        cursor: 'pointer',
        transition: 'background-color 0.1s ease',
    },
    rightGroup: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '8px',
        minWidth: 0,
    },
    backLink: {
        background: 'none',
        border: 'none',
        color: '#0078d4',
        fontSize: '14px',
        cursor: 'pointer',
        textDecoration: 'underline',
        padding: '4px 8px',
        whiteSpace: 'nowrap',
    },
};
export default styles;
//# sourceMappingURL=CalendarNavigation.styles.js.map